/* eslint-disable */


var keyCount = 0;
var editPool = [];
var bodyEvent = null;

function init(editor) {
	editor.originCell = null;
	editor.$editingCell = null;
	editor.editingCellIndex = null;
}

function allCancel() {
	for(var i = 0; i < editPool.length; i++) {
		editPool[i].cancel();
	}
}

function keyup(e, editor) {
	e.preventDefault();
	e.stopPropagation();

	// console.log('keyup', this);
	switch(e.key) {
		case 'Enter':
			var prev = editor.originCell.value;
			var cur = editor.$editingCell.val();
			
			if(editor.originCell.type != typeof cur) {
				if(editor.originCell.type == 'number')
					cur = parseInt(cur, 10);
			}
				
			editor.originCell.data(cur);

			var colDef = editor.column[editor.editingCellIndex.col];
			colDef.onEdited && colDef.onEdited(prev, cur, editor.originCell.cell.index(), editor.originCell.cell);
			editor.onEdited && editor.onEdited(prev, cur, editor.originCell.cell.index(), editor.originCell.cell);
			init(editor);
			break;
		case 'Escape':
			// editor.$editingCell.blur();
			allCancel();
			break;
	}
}

function editDone(editor) {
	var prev = editor.originCell.value;
	var cur = editor.$editingCell.val();
	
	if(editor.originCell.type != typeof cur) {
		if(editor.originCell.type == 'number')
			cur = parseInt(cur, 10);
	}
	
	editor.originCell.data(cur);

	// console.log('editor.originCell', editor.originCell);
	// editor.originCell.cell.row().invalidate();
	var colDef = editor.column[editor.editingCellIndex.col];
	colDef.onEdited && colDef.onEdited(prev, cur, editor.originCell.cell.index(), editor.originCell.cell);
	editor.onEdited && editor.onEdited(prev, cur, editor.originCell.cell.index(), editor.originCell.cell);

	editor.table.draw(true);
	init(editor);
}

function keydown(e, editor) {
	// e.preventDefault();
	// e.stopPropagation();

	// console.log('keydown', this);
	switch(e.key) {
		case 'Enter':
			e.preventDefault();
			e.stopPropagation();
		
			editDone(editor);
			break;
		case 'Escape':
			// editor.$editingCell.blur();
			allCancel();
			break;
		case 'ArrowUp':
		case 'ArrowDown':
		case 'ArrowLeft':
		case 'ArrowRight':
		case 'Home':
		case 'End':
		case 'PageUp':
		case 'PageDown':
			// e.preventDefault();
			e.stopPropagation();	//이벤트 버블링 차단
			break;
	}
}

function gridKeyup(e, editor) {
	
	switch(e.key) {
		case 'Enter':
			e.preventDefault();
			e.stopPropagation();
			makeEditCell.call(this, e, editor);
			break;
		default:
			break;
	}
}

function makeEditCell(e, editor) {
	e.preventDefault();
	e.stopPropagation();

	var cell = this;
	var idx = cell.index();

	if(editor.editingCellIndex && editor.editingCellIndex.col == idx.column && editor.editingCellIndex.row == idx.row) {
		return;
	}
	allCancel();

	if(!editor.column[idx.column]) {
		return;
	}
	
	editor.originCell = {
		cell : cell
	};
	editor.originCell.value = editor.originCell.cell.data();
	editor.originCell.type = typeof editor.originCell.value;
	editor.originCell.data = editor.originCell.cell.data;

	var cellType = editor.column[idx.column].type || 'text';
	
	var cellWidth = $(editor.originCell.cell.node()).width();
	if(cellType === 'text') {
		editor.originCell.data(`<input type="text" id="${editor.labelID}" value="" style="width:${cellWidth}px;"/>`);
	}
	else if(cellType === 'number') {
		editor.originCell.data(`<input type="number" id="${editor.labelID}" value="" style="width:${cellWidth}px;"/>`);
	}
	else if(cellType === 'select') {
		var list = editor.column[idx.column].list;

		if(list instanceof Function) {
			list = list.call(editor.table.row(idx.row).data(), editor.sourceStore);
		}

		var options = '';
		if(list) {
			for(var i = 0; i < list.length; i++) {
				var item = list[i];
				
				if(typeof item == 'string') {
					options += `<option value="${item}">${item}</option>`;
				}
				else {
					options += `<option value="${item.value}">${item.text}</option>`;
				}
			}
		}
		
		editor.originCell.data(`<select id="${editor.labelID}"   style="width:${cellWidth}px; position:fixed; background-color:white;">
		${options}
		</select>`);
		
	}
	editor.$editingCell = $('#' + editor.labelID);
	editor.$editingCell.focus();
	editor.$editingCell.val(editor.originCell.value);

	editor.editingCellIndex = {
		col : idx.column,
		row : idx.row
	};
}


function editable(option) {
	if(!option.dataTable) {
		throw new Error('dataTable is undefined');
	}
	if(!option.columnDefs) {
		throw new Error('columnDefs is undefined');
	}

	var editor = {
		table : option.dataTable,
		labelID : 'datatable_editing_cell_' + (keyCount++),
		column : {},
		onEdited : option.onEdited,
		sourceStore : option.sourceStore || {}
	};
	
	init(editor);

	for(var i = 0; i < option.columnDefs.length; i++) {
		var columnIdx = option.columnDefs[i].targets;
		editor.column[columnIdx] = option.columnDefs[i]
	}

	option.eventTarget = option.eventTarget || 'tbody td';

	// editor.table.attr('contentEditable', true);
	editor.table.on('click', option.eventTarget, function(e) {
		// console.log('click');
		e.stopPropagation();
		// allCancel();
	})
	.on('dblclick', option.eventTarget, function(e) {
		makeEditCell.call(editor.table.cell(this), e, editor);
	})
	.on('key', function ( e, datatable, key, cell, originalEvent ) {
		// console.log(this, e, datatable, key, cell, originalEvent);
		// console.log('gridKeyup');
		gridKeyup.call(cell, originalEvent, editor);
	})
	.on('keydown', '#' + editor.labelID, function(e) {
		keydown.call(this, e, editor);
	})
	.on('change', '#' + editor.labelID, function(e) {
		if(e.target.nodeName === 'SELECT')
			editDone(editor);
	})

	;

	function cancel() {
		if(editor.$editingCell == null) {
			return;
		}

		editor.originCell.data(editor.originCell.value);
		init(editor);
	}

	editPool.push({
		cancel : cancel
	});

	if(!bodyEvent) {
		bodyEvent = allCancel;
		$('body').on('click', bodyEvent);
	}
	
}



export default editable;

